import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FaHeart } from "react-icons/fa";
import { baseURL } from "services";

const Cart = ({ title, slashPrice, amount, onRemove, quantity, totalPrice, img, onSaveProduct, isSaved, onDeleteProduct }) => {
  const [saved, setSaved] = useState(isSaved);
  const token = useSelector((state) => state?.user?.data?.user?.data?.token);
  const savingProducts = useSelector((state) => state?.product?.productSavedByUser?.saved || []);

  const checksaveProductByID = async (id) => {
    try {
      const response = await fetch(`${baseURL}/product/saved`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      const result = await response.json();
      if (result.status === 'success') {
        const isProductSaved = result.data.some((product) => product.id === id);
        setSaved(isProductSaved);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    if (savingProducts?.id) {
      checksaveProductByID(savingProducts.id);
    }
  }, [savingProducts.id]);

  const handleToggleSave = async (e) => {
    e.stopPropagation();
    if (saved) {
      const success = await onDeleteProduct(e);
      if (success) setSaved(false);
    } else {
      const success = await onSaveProduct(e);
      if (success) setSaved(true);
    }
  };

  return (
<div className="relative flex flex-row gap-4 border-b-2 p-4 items-center">
  <div className="h-32 w-32 sm:h-40 sm:w-40">
    <img className="w-full h-full object-contain" src={img} alt={title} />
  </div>
  <div className="w-full space-y-3">
    <div className="flex justify-between w-full items-center">
      <div className="text-left">
        <p className="text-gray-900 font-semibold text-lg">{title}</p>
        <div className="flex items-center gap-2">
          <p className="text-gray-400 line-through">{slashPrice}</p>
          <p className="text-gray-900 font-semibold">{amount}</p>
        </div>
      </div>
    </div>
    <div className="flex gap-4">
      <p className="text-gray-500">Quantity: <span className="text-gray-900">{quantity}</span></p>
      <p className="text-gray-500">Total Price: <span className="text-gray-900">{totalPrice}</span></p>
    </div>
    {/* Heart (Saved) Icon - Positioned Top Right */}
    <div onClick={handleToggleSave} className="absolute top-6 right-2 cursor-pointer">
      {saved ? (
        <img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721855731/ERC/svg_4_b6psf9.svg" alt="Saved" />
      ) : (
        <FaHeart />
      )}
    </div>
    {/* Delete Icon - Positioned Bottom Right */}
    <div className="absolute bottom-6 right-2 cursor-pointer" onClick={onRemove}>
      <img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1724423617/trash_1_s2qqhf.svg" alt="Remove from cart" />
    </div>
  </div>
</div>
  );
};

const SavedItem = ({ title, slashPrice, amount, discount, totalPrice, img, onDeleteProduct }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 border-b-2 p-4 items-center">
      <div className="h-32 w-32 sm:h-40 sm:w-40">
        <img className="w-full h-full object-contain" src={img} alt={title} />
      </div>
      <div className="w-full space-y-3">
        <div className="flex flex-col sm:flex-row sm:justify-between w-full items-center">
          <div className="text-center sm:text-left">
            <p className="text-gray-900 font-semibold text-lg">{title}</p>
            <div className="flex items-center justify-center sm:justify-start gap-2">
              <p className="text-gray-400 line-through">{slashPrice}</p>
              <p className="text-gray-900 font-semibold">{amount}</p>
            </div>
          </div>
          <div className="cursor-pointer" onClick={onDeleteProduct}>
            <img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1724423617/trash_1_s2qqhf.svg" alt="Delete" />
          </div>
        </div>
        <div className="flex flex-col sm:flex-row sm:gap-4">
          <p className="text-gray-500">Discount: <span className="text-gray-900">{discount}</span></p>
          <p className="text-gray-500">Total Price: <span className="text-gray-900">{totalPrice}</span></p>
        </div>
      </div>
    </div>
  );
};

export { Cart, SavedItem };
